
export default {
  'placeInput': {
    'findAPlace': 'Trouver un lieu',
    'place': 'Lieu',
    'addRouteStop': 'Ajouter un arrêt',
    'routePlace': 'Arrêt de l\'itinéraire',
    'routeDestination': 'Destination',
    'placeNameRequired': 'Nom de lieu requis',
    'yourLocation': 'Votre emplacement',
    'couldNotDetermineYourLocation': 'Votre emplacement n\'a pas pu être déterminé. Assurez-vous que vous avez accordé les autorisations requises',
    'useYourLocation': 'Utilisez votre position actuelle',
    'removeInput': 'Supprimer le lieu/le champ',
    'directions': 'Itinéraire',
    'fromYourBrowser': 'Depuis votre appareil',
    'addStartingPlace': 'Ajouter un lieu de départ',
    'startingPlace': 'Lieu de départ',
    'openInputOptions': 'Ouvrir les options de saisie',
    'addInput': 'Ajouter un champ de lieu',
    'switchCoords': 'Changer de coordonnées',
    'rawCoordinate': 'Coordonnées brutes lat,lng',
    'fillOrRemoveInput': 'Recherchez un lieu ou utilisez le carte-bouton à droite',
    'noPlaceFound': 'Aucun résultat trouvé',
    'unknownSearchPlaceError': 'Erreur de recherche de lieu inconnue',
    'approximateDistance': 'Distance approximative en ligne droite du centre actuel de la carte',
    'couldNotDetermineYourPreciseLocationUsingPreviousLocation': 'Il n\'a pas été possible de déterminer votre emplacement précis. Votre emplacement précédent sera utilisé à la place',
    'pleaseTypeSomething': 'Veuillez taper quelque chose à rechercher',
    'toggleDirect': 'Basculer directement d\'ici à l\'endroit suivant',
    'clickOnTheMapToSelectAPlace': 'Choisissez un lieu en cliquant sur un emplacement sur la carte',
    'clickOnTheMapBtnToPickAPlace': 'Cliquez sur ce bouton pour choisir un endroit sur la carte pour cette entrée',
    'goToDirectionsMode': 'Cliquez sur le bouton de directions pour passer en mode de routage',
    'clickToSearchAndShowResultsOnTheMap': 'Cliquez pour rechercher et afficher les résultats sur la carte'
  }
}
